import _ from "lodash";
import {basicContext} from "../../../utils/contextUtils";


const BUSINESS_UNIT_AXIS_ID = '000000000000000000000001';
const GROUP_AXIS_ID = '000000000000000000000002';

const findRelatedMeshes = (context, organizationIDs) => {
    return global.app.SE.OrganizationalMesh.find({
        ...basicContext(context),
        fieldPath: ["attachments.id"],
        query: {
            $or: [
                { "attachments": { $elemMatch: { $in: organizationIDs } } },
                { _id: { $in: organizationIDs } }
            ]
        }
    });
};

const getUniqueAugmentedOrgIDs = (organizationIDs, meshes) => {
    const augmentedOrgIDs = [...organizationIDs];
    if (meshes.length > 0) {
        const relatedOrgIDs = meshes.flatMap(mesh => mesh.attachments.map(org => new global.ObjectID(org.id)));
        augmentedOrgIDs.push(...relatedOrgIDs);
    }
    return _.uniqWith(augmentedOrgIDs, _.isEqual);
};

const findOrgsByIds = (context, orgIds) => {
    return global.app.SE.Organization.find({
        ...basicContext(context),
        fieldPath: ["attachment.id"],
        query: {_id: { $in: orgIds }}
    });
};

export const entity = {
    name: 'Role',
    fields: [
        {path: 'profile', type: 'Profile', link: 'MTO', unique: true},
        {path: 'organizationalAxis', type:'AxisAndMesh', link: 'MTO'},
        {
            path:'profileName',
            fieldPath: ['profile.name'],
            f: function () {
                    return this.profile?.name
            }
        },
    ],
    filters:[
        { //not yet
            name: "byOrganizationalAxis",
            isDefault: false,
            query: function(context) {
                const organizationalAxisID = _.get(context.data, 'organizationalAxis.id')
                return organizationalAxisID ? { $or: [ {"organizationalAxis": new global.ObjectID(organizationalAxisID)},{"exhaustiveScope": true} ]} : {"organizationalAxis": "0"}
            }
        },
        { // verified
            name: "byOrganizationAndMesh",
            isDefault: false,
            async: true,
            query: async function(context, callback) {
                try {
                    const organizations = _.get(context.data, 'organizations', []);
                    if (organizations.length === 0) return callback(null, { _id: null })

                    const axesIDs = new Set([GROUP_AXIS_ID]);
                    //if (organizations[0].joinedEntity === "OrganizationalMesh") {
                    //    axesIDs.add(BUSINESS_UNIT_AXIS_ID);
                    //}

                    const organizationIDs = organizations.map(org => new global.ObjectID(org.id));

                    const meshes = await findRelatedMeshes(context, organizationIDs);
                    if (meshes.length > 0) {
                        axesIDs.add(BUSINESS_UNIT_AXIS_ID);
                    }
                    const uniqueAugmentedOrgIDs = getUniqueAugmentedOrgIDs(organizationIDs, meshes);

                    const orgs = await findOrgsByIds(context, uniqueAugmentedOrgIDs);
                    orgs.forEach(org => axesIDs.add(new global.ObjectID(org.organizationalAxis.id).toString()));

                    const uniqueAxesIDs = Array.from(axesIDs).map(id => new global.ObjectID(id));

                    callback(null, { "organizationalAxis": { $in: uniqueAxesIDs } });
                } catch (e) {
                    callback(e);
                }
            }
        }
    ]
}

export const module_ = {
    object: 'Role',
    tKey: 'fonction',
    category: {
        path: 'process',
        icon: 'repeat'
    },
    defaultSortBy: 'profile',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            {path: 'profile', tKey: "profil", translateName: true},
            {path: 'organizationalAxis', tKey: 'Périmètre', translateName: true},
        ],
        form: [
            {
                path: 'profile',
                tKey: 'profil',
                editable: false,
                translateName: true
                //unique: true
            },
            {
                path: 'organizationalAxis',
                tKey: 'Périmètre',
                editable: false,
                translateName: true
            },
        ],
    }
}